import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {UpdateRefundProcedure} from 'domain/usecases/private/refund/request/update-procedure';
import {RemoteRefundUpdateProcedure} from 'data/usecases/private/refund/request/remote-update-procedure';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeUpdateRefundProcedure = (): UpdateRefundProcedure =>
	new RemoteRefundUpdateProcedure(
		makeBFFApiUrl(RefundFlowEndPoints.procedure),
		makeAuthorizeHttpClientDecorator(),
	);
